<!--
    @name       AppNavgation
    @desc       底部导航
    @props
                active<string>      当前激活的路由

-->

<template>
  <div class="app-navgation app-night-theme">
    <router-link tag="div" to="/" class="app-navgation-item" :class="{'active': active === ''}">
      <img src="/static/img/icon/通用/sy-light.png" alt="" v-if="active === ''">
      <img src="/static/img/icon/通用/sy-gray.png" alt="" v-else>
      首页
    </router-link>
    <router-link tag="div" to="/store" class="app-navgation-item" :class="{'active': active === 'store'}">
      <img src="/static/img/icon/通用/sc-light.png" alt="" v-if="active === 'store'">
      <img src="/static/img/icon/通用/sc-gray.png" alt="" v-else>
      商城
    </router-link>
    <router-link tag="div" to="/mine" class="app-navgation-item" :class="{'active': active === 'mine'}">
      <img src="/static/img/icon/通用/wd-light.png" alt="" v-if="active === 'mine'">
      <img src="/static/img/icon/通用/wd-gray.png" alt="" v-else>
      我的
    </router-link>
  </div>
</template>

<script>
  export default {
    props: ['active']
  }
</script>

<style lang="scss" scoped>
  .app-navgation {
    bottom: 0;
    z-index: 3;
    width: 100%;
    height: 100px;
    display: flex;
    /* padding: 0 30px; */
    position: fixed;
    /*overflow: hidden;*/
    background: #fff;
    box-sizing: border-box;
    justify-content: space-around;
    border-top: 1px solid #dddddd;
  }

  .app-navgation-item {
    width: 25%;
    display: flex;
    font-size: 20px;
    color: #adadad;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    &.find{
      position: relative;
      top: -30px;
      i{
        padding: 10px;
        border: 4px solid #fff;
        border-radius: 50%;
        background: #e3e3e3;
        color: #9699a2;
      }
    }
    img{
      margin-bottom: 10px;
    }

  }

  .app-navgation-icon {
    font-size: 44px;
    display: block;
    margin-bottom: 5px;
    background-repeat: no-repeat;
  }

  .app-navgation-item.active {
    color: #fe0853;
  }

  .activeFind {
    color: #16bdf9!important;
    i{
      background: #fff!important;
      color: #16bdf9!important;
      border-color: #16bdf9 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Navgation/Navgation.vue